module.exports = __webpack_public_path__ + "static/img/screen_normal.b3f1a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/screen_normal.png
// module id = 827
// module chunks = 1